import React from 'react'
import { createComponent } from '@ycos/fela'

const IconWrapper = createComponent('IconWrapper', () => ({
  position: 'absolute',
  top: 'calc(50% - 8px)',
  right: '0px'
}))

export const Lock = () => (
  <IconWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <polygon points="0 16 16 16 16 0 0 0" />
        <path
          fill="#838383"
          d="M7,11 L9,11 L9,9 L7,9 L7,11 Z M3,14 L13,14 L13,6 L3,6 L3,14 Z M7.992,1 C9.651,1 11,2.346 11,4 L11,5 L4.992,5 L4.984,4 C4.984,2.346 6.333,1 7.992,1 L7.992,1 Z M12,5 L12,4 C12,1.791 10.206,0 7.992,0 C5.779,0 3.984,1.791 3.984,4 L3.992,5 L2,5 L2,15 L14,15 L14,5 L12,5 Z"
        />
      </g>
    </svg>
  </IconWrapper>
)
